import { useEffect, useRef, useState } from "react";
import ShareIcon from "@/assets/icons/shareIcons/ShareIcon";
import classes from "./ShareContainer.module.scss";
import Facebook from "@/assets/icons/shareIcons/Facebook";
import LinkedIn from "@/assets/icons/shareIcons/LinkedIn";
import Twitter from "@/assets/icons/shareIcons/Twitter";
import CopyLink from "@/assets/icons/shareIcons/CopyLink";

interface ShareContainerProps {
  content: string;
  articleUrl: string;
}

const ShareContainer = ({ content, articleUrl }: ShareContainerProps) => {
  const [showIcons, setShowIcons] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleShareClick = () => {
    setShowIcons((prevState) => !prevState);
  };

  const handleCopyLink = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(articleUrl)
      .then(() => {
        alert("Link copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy: ", error);
      });
  };

  const handleLinkedInShare = (e: React.MouseEvent) => {
    e.stopPropagation();
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      articleUrl
    )}&title=${encodeURIComponent(content)}`;
    window.open(linkedInUrl, "_blank");
  };

  const handleFacebookShare = (e: React.MouseEvent) => {
    e.stopPropagation();
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      articleUrl
    )}`;
    window.open(facebookUrl, "_blank");
  };

  const handleXcomShare = (e: React.MouseEvent) => {
    e.stopPropagation();
    const xcomUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      articleUrl
    )}&text=${encodeURIComponent(content)}`;
    window.open(xcomUrl, "_blank");
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node)
    ) {
      setShowIcons(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={classes["share-container"]}
      onClick={handleShareClick}
    >
      <div className={classes["share-icon"]}>
        <ShareIcon isFilled={showIcons ? true : false} />
      </div>

      {showIcons && (
        <div className={classes["activated-icons"]}>
          <div onClick={handleCopyLink}>
            <CopyLink />
          </div>
          <div className={classes["divider"]} />
          <div onClick={handleLinkedInShare}>
            <LinkedIn />
          </div>
          <div className={classes["divider"]} />
          <div onClick={handleFacebookShare}>
            <Facebook />
          </div>
          <div className={classes["divider"]} />
          <div onClick={handleXcomShare}>
            <Twitter />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareContainer;
